// extracted by mini-css-extract-plugin
module.exports = {"Container":"NoteListItem_Container__r2JWf"};